import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { AddressLabelsMobileNoComponent } from '../pages/address-labels-mobile-no/address-labels-mobile-no.component';
import { AddressLableMobileNoEnglishComponent } from '../pages/address-lable-mobile-no-english/address-lable-mobile-no-english.component';


@Component({
  selector: 'app-barcode-dialog',
  templateUrl: './barcode-dialog.component.html',
  styleUrl: './barcode-dialog.component.scss'
})
export class BarcodeDialogComponent {

  barcodeForm: FormGroup;
  shortName = {
    वार्षिक: 'वा.',
    त्रैवार्षिक: 'त्रै.',
    पंचवार्षिक: 'पंच.',
    लोकनेता_गंथयात्री_वार्षिक: 'लो.गं.वा.',
    लोकमान्य_ग्रंथयात्री_वार्षिक_वर्गणी: 'लो.ग्रं.वा.व.',
    हिंदुत्व_ग्रंथयात्री: 'हिं.ग्रं.',
    हिंदुत्व_2: 'हिं.2.',
    रामसेवक_ग्रंथयात्री: 'रा.ग्रं.',
  };
  constructor(
    private dialogref: MatDialogRef<BarcodeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private fb: FormBuilder,
    public service: DigisubservicesService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef
  ) {

    this.barcodeForm = this.fb.group({
      weight: [''],
      senderId: [''],
      postalCodes: ['']
    });

  }

  labelsData = [];
  tempdata = [];
  data1 = [];
  today = new Date();
  iscustomer: any;
  isIds: any;
  saveStatus:any="ADD"
  issue_date:any
  stateName:any
  districtName:any
  talukaName:any
  pincode:any
rep:any
officerep:any
delivery_mode_name:any
subname: any
disrep: any

  ngOnInit(): void {
    debugger
    this.barcodeForm.patchValue({
      senderId:"9594965778",
      weight:"70 GM"

    })
     this.barcodeForm.value.senderId="";
    this.labelsData = this.data['addresslabels'];
    this.saveStatus = this.data['saveStatus'];
    console.log("Barcode Data="+this.labelsData);
    this.iscustomer = this.data['iscustomer'];
    this.isIds = this.data['isIds'];
    this.issue_date = this.data['issue_date'];

    this.stateName = this.data['stateName'] || [];
    this.districtName = this.data['districtName'] || [];
    this.talukaName = this.data['talukaName'] || [];
    this.pincode = this.data['pincode'] || [];

    this.rep = this.data['rep'] || [];
    this.officerep = this.data['officerep'] || [];
    this.delivery_mode_name = this.data['delivery_mode_name'] || [];
     this.subname = this.data['subname'] || [];
     this.disrep = this.data['disrep'] || [];

    this.tempdata = this.uniqueid(this.labelsData, (a) => a['district']);
    
  }
  
  sortDataDistrictwise() {
    let postalCodes= this.barcodeForm.getRawValue().postalCodes;
    let weight= this.barcodeForm.getRawValue().weight;
    let senderId= this.barcodeForm.getRawValue().senderId;
    let postalCodeArr=postalCodes.split(",");
    this.labelsData.sort((a, b) => Number(a.pincode) - Number(b.pincode));
    // this.tempdata.sort((a, b) => a.name.localeCompare(b.name, ['en', 'mr']));
    let index1=0;
    for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
      let data = this.labelsData.filter(
        (a) => a['district'] == this.tempdata[index]['district']
      );
     
      data.map((a) => {
        a.shortname = this.shortName[a.Subscription_Type.split(' ').join('_')];
        a.postalCode =postalCodeArr[index1];
        console.log(index1+"="+postalCodeArr[index1])
        a.senderId =senderId;
        a.weight=weight;
        ++index1;
      });

      this.data1.push(data);
      console.log(this.data1);
     
    }
    

    let data = []
    this.data1.forEach(element => {
      element.forEach(data2 => {
        data.push(data2)
      });

    });
    this.data1 = data
    // this.exportToExcel(this.data1);

    if (this.data1.length <= 4) {
      const requiredLength = 5;
      const numberOfItemsToAdd = requiredLength - this.data1.length;

      // Push empty data to fill up the list
      for (let i = 0; i < numberOfItemsToAdd; i++) {
        this.data1.push({
          shortname: '',
          month: '',
          subno: '',
          year: '',
          title: '',
          name: '',
          address: '',
          taluka: '',
          district: '',
          pincode: '',
          state: ''
        });
      }
    }
    const filteredData = this.data1.map((item, index) => ({
      SL: index + 1,
      Barcode: item.postalCode,
      REF: item.subno,
      City: item.e_taluka,
      Pincode: item.e_pincode,
      name: item.e_name,
      ADD1: item.e_address,
      ADD2: item.e_address1,
      ADD3: item.e_address2,
      ADDREMAIL:'',
      ADDRMOBILE: item.mobileNumber,
      SENDERMOBILE:'',
      Weight: item.weight,
      COD:"",
      InsVal:"",
      VPP	:"",
      L	:"",
      B	:"",
      H	:"",
      D	:"",
      ArticleShape:"",
      ContentType	:"",
      Priority:"",
      AltAddress1	:"",
      AltAddress2	:"",
      AltAddress3:"",
      AltCity:"",
      AltState:"",
      AltPincode: "",
      DeliveryAddType: "",
      DeliveryTime: "",
      "DeliveryDate [YYYYMMDD]": "",
      ReferenceNo: "",
      "OtpDelivery(Y/N)": "",
      "SpdsDelivery(Y/N)": ""
      
    }));
  
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, 'Subscription_Export.xlsx');
  }
 
  exportToExcel(){
    this.sortDataDistrictwise();
   
    // if(postalCodeArr.length!=this.labelsData.length){
    //   alert("Postal Code and Tickets Are Not Same !! Postal Codes are="+postalCodeArr.length+" and Tickets Are="+this.labelsData.length)
    //  return ;
    // }
   
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  

    getAddressLabelswithMobileNo() {
      debugger
      // this.sortDataDistrictwise();
      let postalCodes= this.barcodeForm.getRawValue().postalCodes;
      let weight= this.barcodeForm.getRawValue().weight;
      let senderId= this.barcodeForm.getRawValue().senderId;
      let postalCodeArr=postalCodes.split(",");
      // if(postalCodeArr.length!=this.labelsData.length){
      //   alert("Postal Code and Tickets Are Not Same !! Postal Codes are="+postalCodeArr.length+" and Tickets Are="+this.labelsData.length)
      //   // return ;
      // }
         console.log('FilteredlabelsforDispatch', this.labelsData);
         this.dialog.open(AddressLableMobileNoEnglishComponent, {
           data: {
             addresslabels: this.labelsData,
             iscustomer: this.iscustomer,
             isIds: this.isIds,
             postalCodes:postalCodeArr,
             weight:weight,
             senderId:senderId,
             saveStatus:this.saveStatus,
             issue_date:this.issue_date,
             stateName :this.stateName || [],
             districtName:this.districtName || [],
             talukaName :this.talukaName || [],
             pincode :this.pincode,
            rep : this.rep || '',
    officerep : this.officerep || '',
    delivery_mode_name : this.delivery_mode_name || [],
    subname: this.subname || [],
    disrep: this.disrep || [],
           },
           width: '1200px',
           height: '1300px',
           maxWidth: '100%',
         });
       }

       onFileChange(event: any): void {
        const target: DataTransfer = <DataTransfer>event.target;
    
        if (target.files.length !== 1) {
          console.error('Please select one Excel file only.');
          return;
        }
    
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
          const bstr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
    
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
    
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 }) as string[][];
    
          const postalCodes = data
            .map((row) => row[0])
            .filter((val) => val !== undefined && val !== null && val !== '');
    
          const result = postalCodes.join(',');
    
          console.log('Comma-separated postal codes:', result);
    
          // Set the result into the textarea
          this.barcodeForm.get('postalCodes')?.setValue(result);
        };
    
        reader.readAsBinaryString(target.files[0]);
      }
  barcodesForDelete:any=[]
      deleteBarcodesByBarcodeNumbers() {
        let lengthOfRecords=this.barcodeForm.getRawValue().postalCodes.length;
        // if(this.barcodeForm.getRawValue().postalCodes.length!=this.labelsData.length){
        //    alert("Postal Code and Tickets Are Not Same !! Postal Codes are="+this.barcodeForm.getRawValue().postalCodes.length+" and Tickets Are="+this.labelsData.length)
        //    return ;
        //  }
        if(this.barcodeForm.getRawValue().postalCodes.length==0){
          alert("Please Provide Postal Codes");
          return;
        }
    
   
       const request = {
         "barcode_number":  this.barcodeForm.getRawValue().postalCodes
       }
       this.service.deleteBarcodesByBarcodeNumbers(request).subscribe((responseData: any) => {
         alert(lengthOfRecords+" "+responseData.message)
   
       });
     }
   
}
